import { Link } from "@components/ui-kit";
import { t } from "@lingui/macro";
import { useInvoiceDetailStore } from "../../../store";
import { Item } from "../../common";

export const ProformaInvoice = () => {
  const store = useInvoiceDetailStore();

  return (
    <div className="mb-6">
      <Item label={t`Proforma invoice`}>
        {store.invoice?.relatesToOutgoingProforma && (
          <Link
            href={{
              pathname: "/invoices/proforma-invoices/detail",
              query: { id: store.invoice.relatesToOutgoingProforma.id },
            }}
          >
            {`#${store.invoice.relatesToOutgoingProforma.invoice_no}`}
          </Link>
        )}
      </Item>
    </div>
  );
};
